import './Navbar.css';
import { GiHamburgerMenu } from 'react-icons/gi';
import { MdOutlineRestaurantMenu } from 'react-icons/md';
import images from '../../constants/images';
import { Link } from 'react-router-dom';

const Navbar = ({ toggleMenu, setToggleMenu }) => {
  const handleLinkClick = () => {
    setToggleMenu(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <img src={images.charleyslogo} alt="app logo" />
      </div>

      <ul className="navbar-links">
        <li className="p__opensans"><Link to="/home">Home</Link></li>
        <li className="p__opensans"><Link to="/menu">Menu</Link></li>
        <li className="p__opensans"><Link to="/order">Order online</Link></li>
        <li className="p__opensans"><Link to="/findus">Find Us</Link></li>
      </ul>

      <div className="navbar-smallscreen">
        <GiHamburgerMenu
          color="#fff"
          fontSize={27}
          onClick={() => setToggleMenu(true)}
        />

        {toggleMenu && (
          <div className="navbar-smallscreen-overlay flex__center slide-bottom">
            <MdOutlineRestaurantMenu
              fontSize={27}
              className="overlay-close"
              onClick={() => setToggleMenu(false)}
            />

            <ul className="navbar-smallscreen-links">
              <li className="p__opensans">
                <Link to="/home" onClick={handleLinkClick}>Home</Link>
              </li>
              <li className="p__opensans">
                <Link to="/menu" onClick={handleLinkClick}>Menu</Link>
              </li>
              <li className="p__opensans">
                <Link to="/order" onClick={handleLinkClick}>Order Online</Link>
              </li>
              <li className="p__opensans">
                <Link to="/findus" onClick={handleLinkClick}>Find Us</Link>
              </li>
            </ul>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;